import { render, staticRenderFns } from "./CardVerVotantesGeneral.vue?vue&type=template&id=15bbd658&scoped=true"
import script from "./CardVerVotantesGeneral.vue?vue&type=script&lang=js"
export * from "./CardVerVotantesGeneral.vue?vue&type=script&lang=js"
import style0 from "./CardVerVotantesGeneral.vue?vue&type=style&index=0&id=15bbd658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bbd658",
  null
  
)

export default component.exports